// Central social links source. Group-level Instagram uses the founder's
// official account (closest legitimate representation of the group at
// this stage). LinkedIn now uses the confirmed Gopi Gadhvi Group company
// page (also used on the Founder page's platform links).
export const SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/company/gopi-gadhvi-group/",
  instagram: "https://www.instagram.com/gopigadhviofficial/",
  youtube: "https://www.youtube.com/@GopiGadhviOfficial",
};

export const FOUNDER_ARTIST_LINKS = [
  { label: "YouTube", url: "https://www.youtube.com/@GopiGadhviOfficial" },
  { label: "YouTube Music", url: "https://music.youtube.com/@gopigadhviofficial" },
  { label: "Amazon Music", url: "https://music.amazon.com/artists/B0G59119F5/gopi-gadhvi" },
  { label: "Spotify", url: "https://open.spotify.com/artist/2WUE6L3vLvriYBLi1VSITP" },
  { label: "Apple Music", url: "https://music.apple.com/in/artist/gopi-gadhvi/1858831092" },
  { label: "Instagram", url: "https://www.instagram.com/gopigadhviofficial/" },
  { label: "Facebook", url: "https://www.facebook.com/share/1HXCWYEiTt/?mibextid=wwXIfr" },
  { label: "LinkedIn", url: "https://www.linkedin.com/company/gopi-gadhvi-group/" },
];
